import React, { Component } from 'react';
import { BillingUtils } from 'services/billing';
import AccordianList from 'sub_components/Billing/AccordianList';
import BloxButton from 'sub_components/Common/BloxButton';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const questionIconDefault = `${CDN_URL}support/ticketing/invoice-general-default-lg.png`;
const questionSelected = `${CDN_URL}support/ticketing/invoice-general-selected-lg.png`;
class BillingIssueSelection extends Component {
	onClick = (data, id) => {
		const { onSelect } = this.props;
		const invoice = document.getElementById(id);
		const dataArray = [];
		if (invoice) {
			invoice.classList.add('selected');
		}
		dataArray.push(data);
		onSelect('billing', { data: dataArray }, true);
	};

	onMouseEnter = (id, selected) => {
		const icon = document.getElementById(id);
		const questionIcon = selected === 'general' ? questionIconDefault : questionSelected;
		icon.src = questionIcon;
	};
	onMouseLeave = (id, typeIcon) => {
		const icon = document.getElementById(id);
		icon.src = typeIcon;
	};

	updateEditParams = data => {
		const { updateData, closeEditModal } = this.props;
		const dataArray = [];
		dataArray.push(data);
		updateData('billing', null, dataArray);

		closeEditModal();
	};

	render() {
		const { data, invoices, closeModal, phase } = this.props;

		const selected = data.billing ? data.billing[0].invoice_number : null;

		const latestInvoices = BillingUtils.getInvoices(invoices, 3);
		const questionIcon = selected === 'general' ? questionSelected : questionIconDefault;

		return (
			<div className='billing-selection-wrapper'>
				<div className='billing-selection'>
					<div
						id='general-issue'
						className={selected === 'general' ? 'general-issue selected' : 'general-issue'}
						onClick={
							phase === 'edit'
								? () => {
										this.updateEditParams('general');
								  }
								: () => this.onClick('general', 'general-issue')
						}
						onMouseEnter={() => this.onMouseEnter('general', selected)}
						onMouseLeave={() => this.onMouseLeave('general', questionIcon)}
						data-cy='billing-general-issue'
					>
						<div className='icon-section'>
							<img src={questionIcon} id='general' />
						</div>
						<div className='details-section'>
							<div className='title body20'>I have a general billing question.</div>
						</div>
					</div>
					{latestInvoices && (
						<AccordianList
							data={latestInvoices}
							disableDropDown={true}
							lowerFilterAnchor='current-invoices-page'
							customOnClick={phase === 'edit' ? this.updateEditParams : this.onClick}
							enableNav
							selected={selected}
							customIcons={true}
						/>
					)}
				</div>
				{phase !== 'edit' && (
					<div className='cancel-button'>
						<BloxButton
							title='CANCEL'
							enabled={true}
							customClass='blox-button-swipe'
							onClick={closeModal}
							id='cancel-button-swipe'
						/>
					</div>
				)}
			</div>
		);
	}
}

export default BillingIssueSelection;
